export const CertificatePermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'certificate.list-view',
    UPDATE: 'certificate.list-update',
    DELETE: ' certificate.list-delete',
  },
});
